import { Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { DecisionTypes, StatusTypes } from 'Enum/recognitionStatus';
import { useDictionary } from 'Hooks';
import { useEffect, useState } from 'react';

export interface ITreatmentStage {
  stepId: any;
  decisionType: any;
  isCurrentStep: boolean;
}

export interface ITreatment {
  data: ITreatmentStage;
}
export const TreatmentStage = ({ data }: ITreatment) => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Status);
  const [label, setLabel] = useState<{
    text: string;
    bgColor: string;
    border: string;
  }>({ text: '', bgColor: '', border: '' });

  useEffect(() => {
    const { stepId, decisionType, isCurrentStep } = data;
    if (
      decisionType === DecisionTypes.InProcess ||
      decisionType === DecisionTypes.FurtherReference
    ) {
      if (stepId === StatusTypes.REQUEST_EXAMINATION)
        setLabel({
          text: dictionary.steps.step1.name,
          bgColor: '#E7EDFF',
          border: '#B7CCFF',
        });
      else if (stepId === StatusTypes.MEDICAL_OPINION)
        setLabel({
          text: dictionary.steps.step2.name,
          bgColor: '#FFF0ED',
          border: '#FFDCD4',
        });
      else if (stepId === StatusTypes.WAITING_FOR_DECISION) {
        setLabel({
          text: isCurrentStep
            ? dictionary.steps.step3.nameIfCurrent
            : dictionary.steps.step3.name,
          bgColor: '#E7EDFF',
          border: '#B7CCFF',
        });
      } else if (stepId === StatusTypes.MEDICAL_COMMITTEE)
        setLabel({
          text: dictionary.steps.step4.name,
          bgColor: '#FFF7EA',
          border: '#FFEDCE',
        });
      else if (stepId === StatusTypes.DISABILITY_RECOGNITION) {
        setLabel({
          text: dictionary.steps.step5.name,
          bgColor: '#E0F6EF',
          border: '#B8EAD9',
        });
      } else {
        setLabel({
          text: dictionary.steps.step0,
          bgColor: '#E0F6EF',
          border: '#B8EAD9',
        });
      }
    } else if (decisionType === DecisionTypes.Rejection) {
      setLabel({
        text: dictionary.Rejection.label,
        bgColor: '#FBE6E6',
        border: '#F7C4C4',
      });
    } else if (decisionType === DecisionTypes.Pause) {
      setLabel({
        text: dictionary.Pause.subtitle,
        bgColor: '#F4E4FF',
        border: '#E4C1FF',
      });
    } else if (decisionType === DecisionTypes.Recognition) {
      setLabel({
        text: dictionary.Recognition.title,
        bgColor: '#E0F6EF',
        border: '#B8EAD9',
      });
    } else if (decisionType === DecisionTypes.Objection) {
      setLabel({
        text: dictionary.Objection.label,
        bgColor: '#F4E4FF',
        border: '#E4C1FF',
      });
    }
  }, [data, dictionary]);

  return (
    <Typography
      variant='body5'
      sx={{
        width: 'max-content',
        padding: '0 12px 1px 12px',
        borderRadius: '6px',
        bgcolor: label.bgColor,
        border: `1px solid ${label.border}`,
      }}
    >
      {label.text}
    </Typography>
  );
};
